export const API_RESPONSE_STATUS = {
  FORBIDDEN: { status: 403, code: '403' },
  NOT_FOUND: { status: 404, code: '404' },
  PAYLOAD_TOO_LARGE: { status: 413, code: 'payloadTooLarge' },
  INTERNAL_SERVER_ERROR: { status: 500, code: '500' },
} as const;

export const AXIOS_REQUEST_ERROR_TYPE = {
  NO_RESPONSE: { code: 'axiosNoResponse' },
} as const;

export const PARSED_API_ERR_RESPONSE = {
  FORBIDDEN: {
    code: API_RESPONSE_STATUS.FORBIDDEN.code,
    errMessage: `請求身份錯誤。錯誤代碼：${API_RESPONSE_STATUS.FORBIDDEN.code}`,
  },
  NOT_FOUND: {
    code: API_RESPONSE_STATUS.NOT_FOUND.code,
    errMessage: `請求路徑錯誤。錯誤代碼：${API_RESPONSE_STATUS.NOT_FOUND.code}`,
  },
  PAYLOAD_TOO_LARGE: {
    code: API_RESPONSE_STATUS.PAYLOAD_TOO_LARGE.code,
    errMessage: '照片過大，請重拍或挑張較小的照片。',
  },
  INTERNAL_SERVER_ERROR: {
    code: API_RESPONSE_STATUS.INTERNAL_SERVER_ERROR.code,
    errMessage: `伺服器內部錯誤。錯誤代碼：${API_RESPONSE_STATUS.INTERNAL_SERVER_ERROR.code}`,
  },
  NO_RESPONSE: {
    code: AXIOS_REQUEST_ERROR_TYPE.NO_RESPONSE.code,
    errMessage: `收到請求但伺服器沒有回應。錯誤代碼：${AXIOS_REQUEST_ERROR_TYPE.NO_RESPONSE.code}`,
  },
  GRAPHQL_NO_DATA: {
    code: 'graphqlNoData',
    errMessage: '請求GraphQL資料發生錯誤。錯誤代碼：graphqlNoData',
  },
} as const;
